const PrivateControleSessao = {
    tipo: '',
    id_usuario: 0,
    nome_usuario: '',
    token: '',
    refreshToken: '',
    id_empresa: 0,
    filiais: []
}

const ControleSessao = {
    setTipo: (tipo: string) => PrivateControleSessao.tipo = tipo,

    setIdUsuario: (id: number) => PrivateControleSessao.id_usuario = id,

    setNomeUsuario: (nome: string) => PrivateControleSessao.nome_usuario = nome,

    setToken: (token: string) => PrivateControleSessao.token = token,

    setIdEmpresa: (id_empresa: number) => PrivateControleSessao.id_empresa = id_empresa,

    setFiliais: (filiais: { CAB_CODIGO: number, CAB_RAZAO: string }[]) => PrivateControleSessao.filiais = filiais,

    setRefreshToken: (token: string) => PrivateControleSessao.refreshToken = token,

    getTipo: (): string => PrivateControleSessao.tipo,

    getIdUsuario: (): number => PrivateControleSessao.id_usuario,

    getNomeUsuario: (): string => PrivateControleSessao.nome_usuario,

    getToken: (): string => PrivateControleSessao.token,

    getUsuarioInterno: (): boolean => PrivateControleSessao.tipo == 'I',

    getIdEmpresa: (): number => PrivateControleSessao.id_empresa,

    getFiliais: (): { CAB_CODIGO: number, CAB_RAZAO: string }[] => PrivateControleSessao.filiais,

    getRefreshToken: (): string => PrivateControleSessao.refreshToken,
}

export default ControleSessao
